import { Helmet } from 'react-helmet';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  queryFiles, getProjectById, getConversations, createConversation, getMessages,
  getUserFiles, deleteConversation, updateConversation, getUserQuerySets, getProjecUsers,
  projectShare, getUserById, delProjectUserShare
} from '../api';
import './Chatbot.css'
import { useParams } from 'react-router-dom';
import UploadFilesTreading from "../components/upload-files-threading.component";
import { List, Dropdown, Modal as Modal1, message, Input } from 'antd';
import useAuth from '../hooks/useAuth';
import { Spinner, Modal, Button, Form, ListGroup } from 'react-bootstrap';
import html2pdf from 'html2pdf.js';
import { toast } from 'react-toastify';
import AddProjectFiles from "../components/AddProjectFiles";

function Chatbot() {
  const title = 'Queries and Responses';
  const { id } = useParams();
  const [query, setQuery] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const chatEndRef = useRef(null);
  const [project, setProject] = useState(null);
  const [conversation, setConversation] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showFilesModal, setShowFilesModal] = useState(false);
  const [showQuerySetModal, setShowQuerySetModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const handleUploadClose = () => setShowUploadModal(false);
  const handleUploadShow = () => setShowUploadModal(true);
  const handleFilesClose = () => setShowFilesModal(false);
  const handleFilesShow = () => setShowFilesModal(true);
  const handleQuerySetShow = () => setShowQuerySetModal(true);
  const handleShareShow = () => setShowShareModal(true);
  const handleQuerySetClose = () => setShowQuerySetModal(false);
  const handleShareClose = () => setShowShareModal(false);
  const auth = useAuth();
  const user = auth.getSession();
  const [files, setFiles] = useState([]);
  const chatBoxRef = useRef(null);
  const [shouldScrollToBottom, setShouldScrollToBottom] = useState(false);
  const [querySets, setQuerySets] = useState([]);
  const textareaRef = useRef(null);
  const [querySetProgress, setQuerySetProgress] = useState(null);
  const [alert, setAlert] = useState(null);
  const [isEnterpriseUser, setIsEnterpriseUser] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [allFiles, setAllFiles] = useState([]);
  const [projectFileIds, setProjectFileIds] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [permissions, setPermissions] = useState('read');
  const [sharedUsers, setSharedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);

  const fetchProjectDetails = useCallback(async () => {
    if (!id) {
      setFiles([]);
      return;
    }
    try {
      const response = await getProjectById(id);
      const project_data = response.data;
      setProject(response.data);
      setFiles(response.data.files);
      const fileIds = response.data.files.map(file => file.id);
      setProjectFileIds(fileIds);
      setIsEnterpriseUser(user.is_enterprise);
      //console.log("user:",user);

      if (project_data.shared_with && project_data.shared_with.length > 0) {
        // Get shared users with details
        const sharedWithDetails = [];

        for (const share of project_data.shared_with) {
          // Find user details from users list or make a separate call
          try {
            const userResponse = await getUserById(share.user_id);
            //console.log("userResponse:", userResponse);
            sharedWithDetails.push({
              ...share,
              name: `${userResponse.data.firstname} ${userResponse.data.lastname}`,
              email: userResponse.data.email
            });

          } catch (error) {
            // If user details can't be fetched, use what we have
            sharedWithDetails.push({
              ...share,
              name: 'Unknown User',
              email: share.user_id
            });
          }
        }
        setSharedUsers(sharedWithDetails);
      } else {
        setSharedUsers([]);
      }
    } catch (error) {
      console.error('Error fetching project details:', error);
    }
  }, [id]);

  const fetchProjectConversations = useCallback(async () => {
    try {
      const response = await getConversations(id);
      setConversation(response.data);
    } catch (error) {
      console.error('Error fetching project conversations:', error);
    }
  }, [id]);

  const fetchAllFiles = async () => {
    try {
      const response = await getUserFiles();
      setAllFiles(response.data);
    } catch (error) {
      console.error('Error fetching all files:', error);
    }
  };
  const fetchQuerySets = async () => {
    try {
      const response = await getUserQuerySets();
      //console.log("response:", response);
      setQuerySets(response.data);
    } catch (error) {
      console.error('Error fetching all files:', error);
    }
  };
  const fetchAllUsers = async () => {
    try {
      const response = await getProjecUsers();
      setAllUsers(response.data);
    } catch (error) {
      console.error('Error fetching all users:', error);
    }
  };
  useEffect(() => {
    fetchProjectDetails();
    fetchProjectConversations();
    fetchAllFiles();
    fetchQuerySets();
    fetchAllUsers();
  }, [fetchProjectDetails, fetchProjectConversations]);


  useEffect(() => {
    if (shouldScrollToBottom && chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
      setShouldScrollToBottom(false);
    }
  }, [shouldScrollToBottom]);


  const handleCreateConversation = async () => {
    try {
      setChatHistory([]);
      setSelectedConversation(null);

    } catch (error) {
      console.error('Error creating conversation:', error);
    }
  };

  const handleQuerySet = async () => {
    try {
      setChatHistory([]);
      setSelectedConversation(null);
      handleQuerySetShow();
    } catch (error) {
      console.error('Error Query Set:', error);
    }
  };
  const handleShare = async () => {
    try {

      handleShareShow();
    } catch (error) {
      console.error('Error Share:', error);
    }
  };
  const handleConversationClick = async (conversation) => {
    setSelectedConversation(conversation);
    setIsLoading(true);
    try {
      const response = await getMessages(conversation.id);
      const messagesWithTimestamps = response.data.map(message => ({
        ...message,
        timestamp: message.timestamp || new Date().toISOString() // Use existing timestamp or current time as fallback
      }));

      setChatHistory(messagesWithTimestamps.reverse());
      setShouldScrollToBottom(true);
    } catch (error) {
      console.error('Error fetching messages:', error);
    }
    setIsLoading(false);
  };

  const handleUploadComplete = () => {
    setIsUploading(false);
    handleUploadClose()
    fetchProjectDetails();
  };
  const handleUploadingStatus = (status) => {
    setIsUploading(status);
  };

  const handleQueryChange = (e) => {
    setQuery(e.target.value);
    adjustTextareaHeight();
  };

  const handleQuerySetClick = async (qset) => {
    try {
      setIsLoading(true);
      // Create new conversation first
      const response = await createConversation(id);
      const newConversation = {
        ...response.data,
        title: qset.category,
        isQuerySet: true  // Add this flag
      };

      // Update conversation title to query set category
      try {
        await updateConversation(newConversation.id, {
          title: qset.category,
          isQuerySet: true,
          updated_at: new Date().toISOString()
        });
      } catch (error) {
        console.error('Error updating conversation title:', error);
      }

      // Update states for new conversation
      setConversation(prevConversations => [newConversation, ...prevConversations]);
      setSelectedConversation(newConversation);
      setChatHistory([]);

      // Set initial progress
      setQuerySetProgress({ current: 0, total: qset.questions.length });

      // Track all unique filenames
      const allSourceFiles = new Set();

      // Process each question in sequence
      for (let i = 0; i < qset.questions.length; i++) {
        const question = qset.questions[i];
        setQuerySetProgress({ current: i + 1, total: qset.questions.length });

        const currentTime = new Date().toISOString();

        try {
          const queryResponse = await queryFiles(
            question.text,
            project?.id,
            project?.files,
            newConversation.id
          );

          const queryResult = queryResponse.data.answer;

          if (queryResult) {
            // Add source filenames to the set
            queryResult.sources.forEach(source => {
              allSourceFiles.add(source.filename);
            });

            const newMessage = {
              query: question.text,
              answer: queryResult.answer_llm,
              timestamp: currentTime,
              // Don't include sources in each message
              sources: [],
              fromQuerySet: true, // Add this flag for query set entries
              user_id: user.user_id
            };

            setChatHistory(prevHistory => [...prevHistory, newMessage]);
          } else {
            const newMessage = {
              query: question.text,
              answer: "No results found.",
              sources: [],
              timestamp: currentTime,
              user_id: user.username
            };
            setChatHistory(prevHistory => [...prevHistory, newMessage]);
          }

          setShouldScrollToBottom(true);

          // Add delay between questions to prevent overloading
          if (i < qset.questions.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 1000));
          }

        } catch (error) {
          console.error('Error processing question:', error);
          const errorMessage = {
            query: question.text,
            answer: "Error processing query: " + (error.response?.data?.error || error.message),
            sources: [],
            timestamp: currentTime,
            user_id: user.username
          };
          setChatHistory(prevHistory => [...prevHistory, errorMessage]);
          setShouldScrollToBottom(true);
        }
      }

      // Add a final message with all unique source files
      const sourcesMessage = {
        query: "",  // Empty query
        answer: "Sources used for all responses:",
        sources: Array.from(allSourceFiles).map(filename => ({ filename })),
        timestamp: new Date().toISOString(),
        isSourcesOnly: true,  // Add this flag to identify this special message
        user_id: user.username
      };
      setChatHistory(prevHistory => [...prevHistory, sourcesMessage]);

      // Update conversation with the final message
      try {
        await updateConversation(newConversation.id, {
          title: qset.category,
          isQuerySet: true,
          lastMessageTime: new Date().toISOString()
        });
      } catch (error) {
        console.error('Error updating conversation time:', error);
      }

      // Reset states
      setQuerySetProgress(null);
      setIsLoading(false);
      handleQuerySetClose();

      // Show success message
      setAlert({
        variant: 'success',
        message: `Successfully processed ${qset.questions.length} queries from "${qset.category}"`
      });

    } catch (error) {
      console.error('Error processing query set:', error);
      setIsLoading(false);
      setQuerySetProgress(null);
      setAlert({
        variant: 'danger',
        message: 'Error processing query set: ' + (error.response?.data?.error || error.message)
      });
      handleQuerySetClose();
    }
  };


  const handleQuerySubmit = async (e) => {
    if (!query.trim()) return;

    setIsLoading(true);
    let conversation_id = 0;
    const currentTime = new Date().toISOString();

    if (!selectedConversation) {
      const response = await createConversation(id);
      const newConversation = response.data;
      setConversation(prevConversations => [newConversation, ...prevConversations]);
      setSelectedConversation(newConversation);
      conversation_id = newConversation.id;
    } else {
      conversation_id = selectedConversation.id;
    }

    try {
      const response = await queryFiles(query, project?.id, project?.files, conversation_id);
      const queryResult = response.data.answer;

      if (queryResult) {
        const newMessage = {
          query: query,
          answer: queryResult.answer_llm,
          sources: queryResult.sources,
          timestamp: currentTime,
          fromQuerySet: false,  // Add this flag for user entries
          user_id: user.username
        };
        setChatHistory(prevHistory => [...prevHistory, newMessage]);
        setShouldScrollToBottom(true);

        console.log("ChatHistory:", chatHistory);

        // Only update title if it's not a query set conversation
        if (selectedConversation && !selectedConversation.isQuerySet) {
          setConversation(prevConversations => {
            return prevConversations.map(conv =>
              conv.id === conversation_id
                ? {
                  ...conv,
                  title: conv.title === "New Conversation"
                    ? query.substring(0, 30) + "..."
                    : conv.title
                }
                : conv
            );
          });
        }
      } else {
        setChatHistory(prevHistory => [...prevHistory, {
          query: query,
          answer: "No results found.",
          timestamp: currentTime,
          fromQuerySet: false,  // Add this flag for user entries
          user_id: user.username
        }]);
        setShouldScrollToBottom(true);
      }
      setQuery('');
    } catch (error) {
      console.error('API error:', error);
      setChatHistory(prevHistory => [...prevHistory, {
        query: query,
        answer: "Error processing query.",
        timestamp: currentTime,
        fromQuerySet: false,  // Add this flag for user entries
        user_id: user.username
      }]);
      setShouldScrollToBottom(true);
    }
    setIsLoading(false);

    
  };

  const formatResult = (result, t) => {
    let stringResult = typeof result === 'string' ? result : JSON.stringify(result, null, 2);

    stringResult = stringResult.replace(/\n/g, '<br>');
    stringResult = stringResult.replace(/^ +/gm, (match) => {
      return '&nbsp;'.repeat(match.length);
    });
    if (t === "r") return ("<h5>AccessEVA</h5>" + stringResult)
    else return stringResult;
  };

  const handleFileSubmitCompete = () => {
    fetchProjectDetails();
    handleFilesClose();
  }

  const handleDeleteConversation = (conversationId) => {
    Modal1.confirm({
      title: 'Are you sure you want to delete this conversation?',
      onOk: async () => {
        try {
          await deleteConversation(conversationId);
          setConversation(prevConversations =>
            prevConversations.filter(conv => conv.id !== conversationId)
          );
          if (selectedConversation && selectedConversation.id === conversationId) {
            setSelectedConversation(null);
            setChatHistory([]);
          }
        } catch (error) {
          console.error('Error deleting conversation:', error);
          Modal.error({
            title: 'Error',
            content: 'Failed to delete the conversation. Please try again.',
          });
        }
      },
      centered: true,
    });
  };

  const handleUpdateConversation = async (conversation) => {
    // Don't allow updates if it's a query set conversation
    if (conversation.isQuerySet) {
      Modal1.warning({
        title: "Action Not Allowed",
        content: "Query Set conversation titles cannot be modified.",
        centered: true,
      });
      return;
    }

    let newTitle = conversation.title;
    let inputRef = null; // Reference for the input field

    Modal1.confirm({
      title: "Enter new title for the conversation:",
      content: (
        <Input
          defaultValue={conversation.title}
          onChange={(e) => (newTitle = e.target.value)}
          ref={(input) => (inputRef = input)}
          autoFocus
        />
      ),
      centered: true,
      onOk: async () => {
        if (!newTitle || newTitle === conversation.title) return;

        try {
          // Call API to update conversation title
          await updateConversation(conversation.id, { title: newTitle });

          // Update the conversation in the local state
          setConversation((prevConversations) =>
            prevConversations.map((conv) =>
              conv.id === conversation.id ? { ...conv, title: newTitle } : conv
            )
          );

          message.success("Conversation title updated successfully!");
        } catch (error) {
          console.error("Error updating conversation title:", error);
          Modal.error({
            title: "Update Failed",
            content: "Failed to update conversation title. Please try again.",
            centered: true,
          });
        }
      },
    });
  };

  const handleKeyUp = useCallback((e) => {
    //console.log('Key pressed:', e.key);
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleQuerySubmit();
    }
  }, [handleQuerySubmit]);

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  useEffect(() => {
    adjustTextareaHeight();
  }, [query]);

  function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
  function utcToLocal(utcDateString) {
    const date = new Date(utcDateString);
    const localDate = new Date(date.toLocaleString());

    return localDate.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short'
    });
  }

  const generatePDF = (action) => {
    const element = chatBoxRef.current;
    // setIsPdfGenerating(true);

    const opt = {
      margin: [15, 10],
      filename: 'Queries and Responses.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
    };

    if (action === 'save') {
      html2pdf().set(opt).from(element).save().then(() => {
        //setIsPdfGenerating(false);
      });
    } else if (action === 'print') {
      const printContent = `
        <html>
          <head>
            <title>Print Queries and Responses</title>
            <style>
              body { font-family: Arial, sans-serif; }
              .header { text-align: center; font-size: 18px; font-weight: bold; margin-bottom: 20px; }
              .exchange { margin-bottom: 20px; }
              .message { margin-bottom: 10px; }
              .user { font-weight: bold; }
              .response { margin-left: 20px; }
              ul { list-style-type: none; padding-left: 0; }
              @media print {
                @page { margin: 20mm; }
              }
            </style>
          </head>
          <body>
            <div className="header">Conversation History</div>
            ${element.innerHTML}
          </body>
        </html>
      `;

      const printWindow = window.open('', '_blank');
      printWindow.document.write(printContent);
      printWindow.document.close();

      printWindow.onload = function () {
        printWindow.focus();
        printWindow.print();
        printWindow.onafterprint = function () {
          printWindow.close();
          //setIsPdfGenerating(false);
        };
      };
    }
  };


  const handleShareProject = async (e) => {
    e.preventDefault();

    if (!selectedUser) {
      toast.error('Please select a user');
      return;
    }

    setLoading(true);
    try {
      await projectShare(id, { user_id: selectedUser, permissions: permissions });
      toast.success('Project shared successfully');
      setSelectedUser('');
      fetchProjectDetails(); // Refresh the list
    } catch (error) {
      console.error('Error sharing project:', error);
      toast.error(error.response?.data?.error || 'Failed to share project');
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveShare = async (userId) => {
    setLoading(true);
    try {
      await delProjectUserShare(id, userId);
      fetchProjectDetails(); // Refresh the list
    } catch (error) {
      console.error('Error removing share:', error);
      toast.error(error.response?.data?.error || 'Failed to remove access');
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <Helmet>
        <title>{title}</title>
        <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap" rel="stylesheet" />
      </Helmet>

      <nav className="bg-body-tertiary border-bottom">
        <div className="container-fluid d-flex flex-wrap py-2 border-bottom">
          <ul className="nav me-auto align-items-center">
            <li className="nav-item fs-6"><strong>Project:</strong> {project?.name} </li>
          </ul>
        </div>
      </nav>

      <div className="container-fluid mt-3">
        <div className="row g-4" style={{ height: 80 + 'vh' }} >
          <div className="col-md-4 col-lg-3 col-xxl-3 collapse show" id="patientList">
            <div className="sidebar-card">
              <div className="card d-flex flex-column">
                <div className="card-header pt-3">
                  <h4>History - Queries and Responses</h4>
                  <small className="text-muted">
                    {project?.isOwner ? '' : `Shared By:  ${project?.ownerName}`}
                  </small>
                </div>
                <div className="card-body p-0">
                  <ul className="list-group list-group-flush">
                    <List
                      dataSource={conversation}
                      renderItem={(item) => (
                        <List.Item

                          className={`list-group-item ${selectedConversation && selectedConversation.id === item.id ? 'active' : ''}`}
                        >
                          <div
                            className="conversation-item"
                            onClick={() => handleConversationClick(item)}
                          >
                            <div className="conversation-title">{item.title}</div>
                            <small className="conversation-time">
                              {item.lastMessageTime ? utcToLocal(item.lastMessageTime) : ''}
                            </small>
                          </div>
                          {(project?.isOwner || project?.permissions == 'edit' || item.user_id == user.username) &&
                            <div className="conversation-options" onClick={(e) => e.stopPropagation()}>
                              <span
                                className="me-3"
                                onClick={() => handleUpdateConversation(item)}
                                style={{ cursor: item.isQuerySet ? 'not-allowed' : 'pointer', opacity: item.isQuerySet ? 0.5 : 1 }}
                              >
                                <i className="bi bi-pencil"></i>
                              </span>
                              <span
                                className="me-2"
                                onClick={() => handleDeleteConversation(item.id)}
                                style={{ cursor: 'pointer' }}
                              >
                                <i className="bi bi-trash"></i>
                              </span>
                            </div>
                          }
                        </List.Item>
                      )}
                    />
                  </ul>
                </div>

                <div className="card-footer">
                  <button
                    className="btn btn-primary btn-sm my-2"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFooter"
                    aria-expanded="false"
                    aria-controls="collapseFooter"
                  >
                    Files Used for Queries and Responses
                  </button>
                  <div className="collapse mt-2" id="collapseFooter">

                    <div>
                      {(project?.isOwner) && <h6>Add Files(s) to Project</h6>}
                    </div>
                    {(project?.isOwner) &&
                      <div className="d-flex flex-wrap">
                        <button type="button" className="btn btn-outline-primary btn-sm me-1 mb-1" onClick={handleUploadShow}>Attach New</button>
                        <button type="button" className="btn btn-outline-primary btn-sm mb-1" onClick={handleFilesShow}>Attach from Resources</button>
                      </div>
                    }
                    <ul className="list-group list-group-flush mb-3">
                      <List
                        dataSource={files}
                        renderItem={(item) => (
                          <List.Item className="file-item list-group-item list-group-item-action">
                            <div className="file-info-container">
                              <div className="file-name-container" title={item.name}>
                                <span className="file-name">{item.name}</span>
                              </div>
                              <small className="file-size text-muted">
                                {formatFileSize(item.size)}
                              </small>
                            </div>
                          </List.Item>
                        )}
                      />
                    </ul>

                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="col h-100 d-flex flex-column">
            <div className="row justify-content-evenly">
              <div className="">
                <div className="card full-height d-flex flex-column">
                  <div className="card-header pt-3  d-flex justify-content-between ">
                    <div><h4>
                      Queries and Responses
                      {selectedConversation?.title &&
                        selectedConversation.title !== "New Conversation" &&
                        selectedConversation.title.trim() !== "" && (
                          <span className="text-muted">: {selectedConversation.title}</span>

                        )}
                    </h4></div>
                    <div>
                      {(project?.isOwner || project?.permissions == 'edit' || !isEnterpriseUser) && (
                        <button className="btn btn-outline-primary m-1" onClick={handleCreateConversation}>
                          New Query
                        </button>
                      )}
                      {isEnterpriseUser && (project?.isOwner || project?.permissions == 'edit') && (
                        <button className="btn btn-outline-primary m-1" onClick={handleQuerySet} >
                          Query Set
                        </button>
                      )}
                      {isEnterpriseUser && project?.isOwner && (
                        <button className="btn btn-outline-primary m-1" onClick={handleShare} >
                          Share
                        </button>
                      )}
                      <button className="btn btn-outline-primary m-1" onClick={() => generatePDF('save')} >
                        Save as PDF
                      </button>

                    </div>
                  </div>
                  <div className="card-body scroll-box" >
                    <div className="chat-container">
                      <div className="chat-box" id="chat-box" ref={chatBoxRef}>

                        {querySetProgress && (
                          <div className="alert alert-info">
                            <Spinner animation="border" size="sm" className="me-2" />
                            Processing query {querySetProgress.current} of {querySetProgress.total}...
                          </div>
                        )}

                        {
                          chatHistory.map((entry, index) => (
                            <div key={index} className="exchange">
                              {!entry.isSourcesOnly ? (
                                // Regular message for both query set and user entry
                                <>
                                  <div className="message user">
                                    <strong>{(entry.user_id) ? entry.user_id : selectedConversation.user_id }: </strong>
                                    <span dangerouslySetInnerHTML={{ __html: formatResult(entry.query, 'q') }}></span>
                                    <br />
                                    <small className="text-muted ml-2">
                                      {utcToLocal(entry.timestamp)}
                                    </small>
                                  </div>
                                  <div className="message response"
                                    dangerouslySetInnerHTML={{ __html: formatResult(entry.answer, 'r') }}>
                                  </div>

                                  {/* Only show sources if it's a user entry query (not from query set) and has sources */}
                                  {!entry.fromQuerySet && entry.sources && entry.sources.length > 0 && (
                                    <div className="message response">
                                      <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                                        {entry.sources.map((s, i) => (
                                          <li key={i}>
                                            <strong>{s.filename}</strong>
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  )}
                                </>
                              ) : (
                                // Sources summary message for query set
                                <div className="message response">
                                  <strong>{entry.answer}</strong>
                                  <ul style={{ listStyleType: 'none', padding: 0, margin: '10px 0' }}>
                                    {entry.sources.map((s, i) => (
                                      <li key={i}>
                                        <strong>{s.filename}</strong>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </div>
                          ))}
                        <div ref={chatEndRef} />
                      </div>
                    </div>
                  </div>
                  {(project?.isOwner || project?.permissions == 'edit' || !isEnterpriseUser) && (
                    <div className="card-footer">
                      <div className="input-group input-box flex-nowrap">
                        <textarea
                          ref={textareaRef}
                          value={query}
                          onChange={(e) => handleQueryChange(e)}
                          onKeyUp={handleKeyUp}
                          placeholder="Type a Query..."
                          disabled={isLoading}
                          className="form-control auto-resize-textarea"
                        />
                        <Button
                          className="btn btn-primary btn-sm"
                          type="button"
                          disabled={isLoading}
                          onClick={handleQuerySubmit}
                        >
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!isLoading} />
                          <span className="px-2">Query</span>
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Upload Modal */}
      <Modal show={showUploadModal} onHide={handleUploadClose}
        backdrop="static" centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Vector File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UploadFilesTreading
            onUploadComplete={handleUploadComplete}
            onCancel={() => {
              setIsUploading(false);
              handleUploadClose();
            }}
            onUploadingStatusChange={handleUploadingStatus}
            projectId={id}
          />
        </Modal.Body>
      </Modal>

      {/* Attach File Modal */}
      <Modal show={showFilesModal} onHide={handleFilesClose}
        backdrop="static" centered
      >
        <Modal.Header closeButton>
          <div>
            <h1 className="modal-title fs-5" id="attachFileLabel">Attach from Resources</h1>
            <p className="mb-0">Select and Attach Previously-Vectored Files from Resources</p>
          </div>
        </Modal.Header>
        <Modal.Body>
          <AddProjectFiles
            onComplete={handleFileSubmitCompete}
            onCancel={handleFilesClose}
            projectId={id}
            projectFileIds={projectFileIds}
          />
        </Modal.Body>
      </Modal>

      {/* Query Set Modal */}
      <Modal show={showQuerySetModal} onHide={handleQuerySetClose} centered>
        <Form>
          <Modal.Header closeButton>
            <Modal.Title>Query Sets</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              {isLoading ? (
                <div className="text-center my-3">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Processing queries...</span>
                  </Spinner>
                  <p className="mt-2">Processing query set...</p>
                </div>
              ) : (
                <table className="table table-borderless table-thead-bordered table-nowrap table-align-middle card-table table-striped mb-0">
                  <thead className="thead-light border-bottom">
                    <tr>
                      <th className="ps-3">Title</th>
                      <th className="text-end pe-3">Options</th>
                    </tr>
                  </thead>
                  <tbody>
                    {querySets.map((set, index) => (
                      <tr key={index}>
                        <td>{set.category}</td>
                        <td className="text-end pe-3">
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => handleQuerySetClick(set)}
                            disabled={isLoading}
                          >
                            Apply Query Set
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleQuerySetClose} disabled={isLoading}>
              Close
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Share Modal */}
      <Modal show={showShareModal} onHide={handleShareClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Share Project</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <Form onSubmit={handleShareProject}>
            <Form.Group className="mb-3">
              <Form.Label>Select User</Form.Label>
              <Form.Select
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.target.value)}
                disabled={loadingUsers}
              >
                <option value="">Select a user</option>
                {allUsers.map(user => (
                  <option key={user.id} value={user.id}>
                    {user.display_name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Permissions</Form.Label>
              <Form.Select
                value={permissions}
                onChange={(e) => setPermissions(e.target.value)}
              >
                <option value="read">Read Only</option>
                <option value="edit">Edit</option>
              </Form.Select>
              <Form.Text muted>
                Read Only can view and chat. Edit can also modify project settings.
              </Form.Text>
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              disabled={loading || !selectedUser}
            >
              {loading ? <><Spinner size="sm" animation="border" /> Sharing...</> : 'Share'}
            </Button>
          </Form>

          <hr />

          <h5 className="mt-4 mb-3">Shared With</h5>
          {loading ? (
            <div className="text-center my-3">
              <Spinner animation="border" size="sm" /> Loading...
            </div>
          ) : sharedUsers.length > 0 ? (
            <ListGroup>
              {sharedUsers.map((share) => (
                <ListGroup.Item
                  key={share.user_id}
                  className="d-flex justify-content-between align-items-center"
                >
                  <div>
                    <div>{share.name}</div>
                    <small className="text-muted">
                      {share.email} • {share.permissions === 'read' ? 'Read Only' : 'Edit'}
                    </small>
                  </div>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleRemoveShare(share.user_id)}
                    disabled={loading}
                  >
                    Remove
                  </Button>
                </ListGroup.Item>
              ))}
            </ListGroup>
          ) : (
            <p className="text-muted">This project isn't shared with anyone yet.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleShareClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
}

export default Chatbot;
